import { render } from "./KapibaraSlider.vue?vue&type=template&id=17380d3b"
import script from "./KapibaraSlider.vue?vue&type=script&lang=js"
export * from "./KapibaraSlider.vue?vue&type=script&lang=js"

import "./KapibaraSlider.vue?vue&type=style&index=0&id=17380d3b&lang=scss"

import exportComponent from "D:\\experement\\kapibara\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__